import React, { memo } from 'react'
import { Box, Card, Stack } from '@mui/material'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import CustomTextField from '../shared/inputs/CustomTextField'
import CustomForm from '../shared/inputs/CustomForm'

const ChangePassword = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, oldPassword, newPassword, isProcessing },
  t,
  isPresent
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CustomForm onFormSubmit={onFormSubmit}>
        <CardHeading title={t('user-account.change-password')} />
        <Box
          sx={{
            rowGap: 3,
            columnGap: 2,
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' }
          }}
        >
          <CustomTextField
            label={t('user-account.old-password')}
            eyePassword
            error={t(error[ACCOUNT_PROFILE_DISPATCH.OLD_PASSWORD])}
            success={t(success[ACCOUNT_PROFILE_DISPATCH.OLD_PASSWORD])}
            value={oldPassword}
            onChange={(value) =>
              dispatchAction(ACCOUNT_PROFILE_DISPATCH.OLD_PASSWORD, value)
            }
          />
          <CustomTextField
            label={t('user-account.new-password')}
            eyePassword
            error={t(error[ACCOUNT_PROFILE_DISPATCH.NEW_PASSWORD])}
            success={t(success[ACCOUNT_PROFILE_DISPATCH.NEW_PASSWORD])}
            value={newPassword}
            onChange={(value) =>
              dispatchAction(ACCOUNT_PROFILE_DISPATCH.NEW_PASSWORD, value)
            }
          />
        </Box>
        <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
          <SubmitButton
            size='default'
            label={t('common.save')}
            loading={isPresent && isProcessing}
          />
        </Stack>
      </CustomForm>
    </Card>
  )
}

export default memo(ChangePassword)
